<template>
  <bm-number
    :suffix="$m.units_plato_suffix"
    :value="value"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  />
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";

/**
 * Specialised number component for Degrees Plato
 */

export default defineComponent({
  name: "BmPlato",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Number as PropType<number | null>,
      required: false,
      default: null,
    },
  },
});
</script>
